'use strict';

var jsxRuntime = require('react/jsx-runtime');

const Service = ()=>{
    return jsxRuntime.jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        className: "text-primary",
        children: [
            jsxRuntime.jsx("path", {
                d: "M37 20C37 11.1634 29.5008 4 20.25 4C10.9992 4 3.5 11.1634 3.5 20",
                stroke: "#212121",
                strokeWidth: "1.4"
            }),
            jsxRuntime.jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M31.2833 29.841C33.3285 27.3828 34.5575 24.2288 34.5575 20.7894C34.5575 12.9411 28.1582 6.57886 20.2641 6.57886C12.3701 6.57886 5.9707 12.9411 5.9707 20.7894C5.9707 28.6376 12.3701 34.9999 20.2641 34.9999C23.2239 34.9999 25.9735 34.1055 28.2545 32.5738L32.3111 33.6544L31.2833 29.841Z",
                fill: "white"
            }),
            jsxRuntime.jsx("path", {
                d: "M31.2833 29.841L30.7452 29.3933C30.5996 29.5683 30.5482 29.8033 30.6075 30.0231L31.2833 29.841ZM28.2545 32.5738L28.4347 31.8974C28.2397 31.8454 28.0318 31.8801 27.8643 31.9926L28.2545 32.5738ZM32.3111 33.6544L32.1309 34.3308C32.3726 34.3952 32.6302 34.3258 32.8068 34.1487C32.9834 33.9716 33.0521 33.7137 32.987 33.4723L32.3111 33.6544ZM33.8575 20.7894C33.8575 24.0588 32.69 27.0558 30.7452 29.3933L31.8214 30.2887C33.9671 27.7097 35.2575 24.3987 35.2575 20.7894H33.8575ZM20.2641 7.27886C27.7754 7.27886 33.8575 13.3316 33.8575 20.7894H35.2575C35.2575 12.5507 28.5409 5.87886 20.2641 5.87886V7.27886ZM6.6707 20.7894C6.6707 13.3316 12.7528 7.27886 20.2641 7.27886V5.87886C11.9873 5.87886 5.2707 12.5507 5.2707 20.7894H6.6707ZM20.2641 34.2999C12.7528 34.2999 6.6707 28.2472 6.6707 20.7894H5.2707C5.2707 29.0281 11.9873 35.6999 20.2641 35.6999V34.2999ZM27.8643 31.9926C25.6953 33.4492 23.0808 34.2999 20.2641 34.2999V35.6999C23.3669 35.6999 26.2518 34.7619 28.6448 33.1549L27.8643 31.9926ZM32.4913 32.978L28.4347 31.8974L28.0743 33.2502L32.1309 34.3308L32.4913 32.978ZM30.6075 30.0231L31.6352 33.8366L32.987 33.4723L31.9592 29.6588L30.6075 30.0231Z",
                fill: "#212121"
            }),
            jsxRuntime.jsx("ellipse", {
                cx: "17.4841",
                cy: "16.8423",
                rx: "1.19112",
                ry: "1.57895",
                fill: "#212121"
            }),
            jsxRuntime.jsx("ellipse", {
                cx: "23.0427",
                cy: "16.8423",
                rx: "1.19112",
                ry: "1.57895",
                fill: "#212121"
            }),
            jsxRuntime.jsx("path", {
                d: "M22.1463 19.7439C22.4225 19.7439 22.6483 19.9691 22.6004 20.2411C22.3831 21.4747 21.4197 22.9018 20.2641 22.9018C19.1085 22.9018 18.145 21.4747 17.9277 20.2411C17.8798 19.9691 18.1057 19.7439 18.3818 19.7439H22.1463Z",
                fill: "#212121"
            }),
            jsxRuntime.jsx("rect", {
                x: "2",
                y: "16",
                width: "5.56032",
                height: "10.26",
                rx: "2",
                fill: "currentColor",
                stroke: "#212121",
                strokeWidth: "1.4"
            }),
            jsxRuntime.jsx("rect", {
                x: "32.4395",
                y: "16",
                width: "5.56032",
                height: "10.26",
                rx: "2",
                fill: "currentColor",
                stroke: "#212121",
                strokeWidth: "1.4"
            })
        ]
    });
};

module.exports = Service;
